var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10427_168736)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.1512,
    cy: 39.1512,
    r: 36.8485,
    fill: "#DBDCE0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.8485,
    cy: 36.8485,
    r: 36.8485,
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3888 34.5752C29.7553 34.5752 26.9258 31.452 26.9258 27.5557C26.9258 23.8295 29.7862 20.6289 33.3888 20.6289C36.9913 20.6289 39.8671 23.8295 39.8671 27.5402C39.8671 31.452 37.0377 34.5752 33.3888 34.5752ZM48.4638 33.663C51.587 33.663 54.0918 36.1832 54.0918 39.2446C54.0918 41.332 52.9631 43.1255 50.984 44.2542L52.2519 45.5066C52.7003 46.0013 52.6848 46.6971 52.2519 47.1455L50.7985 48.6453L51.6953 49.6039C52.1127 50.0523 52.1746 50.7481 51.7107 51.2119L49.2832 53.6394C48.8658 54.0568 48.2628 54.0104 47.8917 53.6857L46.3765 52.3406C46.0982 52.0777 45.9435 51.6912 45.9435 51.3356V44.3006C44.0418 43.3729 42.8512 41.4402 42.8512 39.2446C42.8512 36.1832 45.3405 33.663 48.4638 33.663ZM48.4638 36.0596C47.6134 36.0596 46.8867 36.7862 46.8867 37.683C46.8867 38.5025 47.6134 39.2601 48.4638 39.2601C49.3296 39.2601 50.0563 38.5025 50.0563 37.683C50.0563 36.7862 49.3296 36.0596 48.4638 36.0596ZM23.4779 49.2637C21.3596 49.2637 20.0918 48.2124 20.0918 46.4652C20.0918 42.538 25.3797 37.2192 33.3888 37.2192C35.8781 37.2192 38.0891 37.7294 39.9754 38.5643C39.7898 41.332 40.7794 44.0068 43.0213 45.8777V49.2637H23.4779Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10427_168736"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75.9997,
    height: 76,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceid);
export default __webpack_public_path__ + "static/media/faceid.06f65b15e3d75df4142cb43e55527498.svg";
export { ForwardRef as ReactComponent };